import { useEffect, useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover'
import { Tip } from '@/shared/components/ui/tooltip'
import { cn } from '@/shared/lib/utils'
import type { NodeMoreOpItem } from '../model/types'
import { CategorizedOpMenu } from './CategorizedOpMenu'
import QuickLink from "@/assets/images/ic_quick_link.svg";

export interface NodeMoreOpPopoverProps {
  ops: NodeMoreOpItem[]
  sourceNodeType: string
  label?: string
  openRequestId?: number | null
  onSelect?: (item: NodeMoreOpItem) => void
}

export function NodeMoreOpPopover({
  ops,
  sourceNodeType,
  label = '快速连接',
  openRequestId,
  onSelect,
}: NodeMoreOpPopoverProps) {
  const [open, setOpen] = useState(false)
  const isDisabled = ops.length === 0

  useEffect(() => {
    if (!openRequestId || isDisabled) {
      return
    }

    setOpen(true)
  }, [isDisabled, openRequestId])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tip content={isDisabled ? '暂无更多操作' : `${label} (Q)`} delayDuration={0}>
        <PopoverTrigger asChild>
          <button
            type="button"
            disabled={isDisabled}
            aria-label={label}
            onPointerDown={(event) => {
              if (isDisabled) {
                return
              }

              event.preventDefault()
            }}
            className={cn(
              'nodrag inline-flex h-6 w-auto min-w-6 items-center justify-center gap-0.5 rounded-full border border-transparent px-1 text-[#d0d0d0] transition hover:bg-[#3d3d3d] hover:text-white',
              open && 'bg-[#3d3d3d] text-white',
              isDisabled && 'cursor-not-allowed opacity-40 hover:bg-transparent hover:text-[#d0d0d0]',
            )}
          >
            <img alt="快速连接" className="h-4 w-4" src={QuickLink} />
            <ChevronDown className={cn('h-3.5 w-3.5 transition-transform duration-200', open && 'rotate-180')} />
          </button>
        </PopoverTrigger>
      </Tip>

      <PopoverContent
        align="start"
        side="bottom"
        sideOffset={10}
        className="max-h-[500px] w-[200px] rounded-[8px] border border-[#494949] bg-[#292929] p-0 px-2 py-2 shadow-[0_18px_48px_rgba(0,0,0,0.48)] ring-0"
      >
        <CategorizedOpMenu
          ops={ops}
          sourceNodeType={sourceNodeType}
          onSelect={(item) => {
            onSelect?.(item)
            setOpen(false)
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
